<template>
  <div>
    <BaseFrame
      @save="savePlan"
      @clear="handleReset"
      @cancel="handleToStocktakingPlan"
      :save-loading="saveLoading"
      save-text="保存">
      <div slot="content">
        <lk-form
          :model="planForm"
          label-position="right"
          :label-width="140"
          :rules="planRules"
          ref="planForm">
          <div class="mb16">
            <lk-card title="盘点计划信息">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="盘点计划名称:" prop="name">
                    <lk-input clearable v-model.trim="planForm.name" :maxlength="50"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="是否含0在库数量商品:" prop="hasZero">
                    <lk-select clearable v-model.trim="planForm.hasZero" @on-change="handleChange">
                      <lk-option v-for="item in hasZeros" :key="item.id" :value="item.id">
                        {{item.name}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="盘点类型:" prop="operatorType">
                    <lk-select clearable v-model.trim="planForm.operatorType" @on-change="operatorTypeSelect">
                      <lk-option v-for="item in checkList" :key="item.id" :value="item.id">
                        {{item.type}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="盘点方式:" prop="operatorPattern">
                    <lk-select clearable v-model.trim="planForm.operatorPattern">
                      <lk-option v-for="item in checkPatterns" :key="item.id" :value="item.id">
                        {{item.pattern}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="盘点人员:" prop="operatorIdLists">
                    <lk-select clearable v-model.trim="planForm.operatorIdLists" :multiple="true">
                      <lk-option v-for="item in operatorList" :key="item.id" :value="item.id">
                        {{item.name}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="盘点时间:" prop="operatorTimeStr">
                    <lk-date-picker
                      type="datetime"
                      format="yyyy-MM-dd HH:mm"
                      placeholder="请选择"
                      :editable="false"
                      v-model="planForm.operatorTimeStr"
                      :options="validTimeOptions"
                      :time-picker-options="{ steps: [1, 15]}"
                    >
                    </lk-date-picker>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row>
                <lk-col span="22">
                  <lk-form-item label="盘点仓库:" prop="warehouseIds">
                    <div class="split-line">
                      <lk-checkbox
                        :indeterminate="indeterminate"
                        :value="checkAll"
                        @click.prevent.native="handleCheckAll">全选
                      </lk-checkbox>
                    </div>
                    <lk-checkbox-group v-model="planForm.warehouseIds" @on-change="checkAllGroupChange">
                      <lk-checkbox
                        v-for="item in warehouseList"
                        :label="item.id"
                        :key="item.id">{{item.name}}
                      </lk-checkbox>
                    </lk-checkbox-group>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="mb16">
            <lk-card class="clear" title="盘点商品信息">
              <lk-row :gutter="16">
                <lk-col span="5" class="leftMargin">
                  <lk-form-item label="商品范围:" prop="goodsRange">
                    <lk-select v-model.trim="planForm.goodsRange">
                      <lk-option v-for="item in goodsChecks" :key="item.id" :value="item.id">
                        {{item.key}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
            </lk-row>

            <!-- 指定部分商品 -->
            <lk-row :gutter="16" v-if="planForm.goodsRange==2">
              <lk-col>
                <div style="display:flex;height:30px;">
                  <div>是否全选：</div>
                <div>
                  <lk-switch @on-change="handleSwitchChange" v-model="switchStatus">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </lk-switch>
                </div>
              </div>
              <lk-table
                v-if="isshow"
                border
                :columns="columns"
                :data="tableData"
                @on-select="handleTempSelect"
                @on-select-cancel="handleTempCancel"
                @on-select-all="handleSelectAll"
                @on-select-all-cancel="handleSelectAllCancel">
              </lk-table>
              <lk-Page
                class="pages"
                show-sizer
                show-elevator
                show-total
                @on-page-size-change="handlePageSize"
                @on-change="handlePage"
                :total="count"
                :current="page"
                :page-size-opts="[10,20,50]">
              </lk-Page>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16" v-if="planForm.goodsRange==3">
            <lk-col span="16" class="leftMargin">
              <lk-form-item label="规则名称:" >
                {{ruleName}}
              </lk-form-item>
            </lk-col>
            <lk-col span="16" class="leftMargin">
              <lk-form-item label="抽盘规则:" >
                {{goodsConditionDesc}}
              </lk-form-item>
            </lk-col>
          </lk-row>
          </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
    <DTPModal
      v-model="resetConfirmVisiable"
      @confirm="confirmReset"
      content="重置将取消当前所做更改"
    ></DTPModal>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import inventory from '../../services/inventory';
import DTPModal from '../../components/DTPModal.vue';
import timeStampDatePicker from '../../components/timeStampDatePicker.vue'
import utils from '../../libs/utils';
import tools from '../../services/tools';

export default {
  name: 'branchInfo',
  components: {
    BaseFrame,
    DTPModal,
    tools,
    timeStampDatePicker,
  },
  data() {
    return {
      goodsCondition: '',
      ruleName: '',
      goodsConditionDesc: '',
      goodsChecks: [{ key: '全部商品', id: 1 }, { key: '指定部分商品', id: 2 }, { key: '按抽盘规则', id: 3 }],
      switchStatus: true,
      saveLoading: false,
      resetConfirmVisiable: false,
      warehouseList: [],
      hasZeros: [{
        id: 1,
        name: '是',
      }, {
        id: 2,
        name: '否',
      }],
      planForm: {
        name: null,
        hasZero: null,
        operatorType: null, //盘点类型
        operatorPattern: null, //盘点方式
        operatorTime: null, //盘点时间
        operatorTimeStr: null, // 盘点时间字符串格式
        operatorIdLists: [], //盘点人员
        warehouseIds: [],
        isAllWarehouse: 1,
        goodsRange: 1,
      },
      checkList: [],
      checkPatterns: [],
      operatorList: [], // 从后端获取盘点人员列表
      tempGoods: [], //存放表格中选中的数据
      validTimeOptions: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      allWarehouseIds: [],
      tableData: [],
      planRules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
          {
            validator: this.nameExistValidator,
            trigger: 'blur',
          },
        ],
        hasZero: [
          {
            required: true,
            message: '请选择是否包含0库存商品',
            trigger: 'change',
            type: 'number',
          },
        ],
        operatorType: [
          {
            required: true,
            message: '请选盘点类型',
            trigger: 'change',
            type: 'number',
          }
        ],
        operatorPattern: [
          {
            required: true,
            message: '请选盘点方式',
            trigger: 'change',
            type: 'number',
          }
        ],
        operatorTimeStr: [
          {
            required: true,
            message: '请选盘点时间',
            trigger: 'change',
            type: 'date',
          }
        ],
        operatorIdLists: [
          {
            required: true,
            message: '请选盘点人员',
            trigger: 'change',
            type: 'array'
          }
        ],
        operatorHoursAndMinutes: [
          {
            required: true,
            message: '请选小时分钟',
            trigger: 'change',
            type: 'date',
          }
        ],
        goodsRange: [
          {
            required: false,
            message: '请选商品范围',
            trigger: 'change',
            type: 'number',
          },
        ],
      },
      columns: [
        {
          title: '序号',
          width: 60,
          render: (h, params) => h('span', params.index + (this.page - 1) * this.size + 1),
        },
        {
          title: '通用名首字母',
          key: 'initial',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 110,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '是否有库存',
          key: 'hasZero',
          minWidth: 110,
          tooltip: true,
        },
      ],
      page: 1,
      size: 10,
      count: 0,
      indeterminate: false,
      checkAll: false,
      isshow: true,
    };
  },
  computed: {
    selectedTempGoodsIds() {
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item);
      });
      return result;
    }
  },
  methods: {
    handleChange() {
      this.getInventoryData();
    },
    handleSwitchChange(value) {
      if (!value) {
        this.columns.unshift({
          type: 'selection',
          width: 60,
          align: 'center',
        })
        this.tempGoods = [];
        this.isshow = false;
        setTimeout(() => {
          this.isshow = true;
        }, 0)
      } else {
        this.tempGoods = [];
        this.columns.shift(0, 1);
      }
    },
    getWarehouseList() {
      return inventory.warehouseList({}).then((res) => {
        if (res.data.status === 200) {
          res.data.data.list.forEach((item) => {
            const { id, warehouseName: name } = item;
            this.allWarehouseIds.push(id);
            this.warehouseList.push({ id, name });
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInventoryData() {
      const params = {};
      if (this.planForm.warehouseIds && this.planForm.warehouseIds.length > 0) {
        params.warehouseIds = this.planForm.warehouseIds;
      }
      params.hasZero = this.planForm.hasZero;
      params.page = this.page;
      params.size = this.size;
      return inventory.stocktakingRecordListCondition(params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          list.forEach((item) => {
            item._checked = this.selectedTempGoodsIds.includes(item.id);
            if (item.hasZero)
            item.hasZero = item.hasZero === 1 ? '否' : '是';
          })
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSearch() {
      this.page = 1;
      this.size = 10;
      this.getInventoryData();
    },
    savePlan() {
      this.$refs.planForm.validate((valid) => {
        if (valid) {
          let now = Date.now();
          let selectTime = new Date(this.planForm.operatorTimeStr).getTime();
          if (now > selectTime) {
            this.$Message.error('盘点时间需大于当前时间');
            return
          }
          this.planForm.operatorTime = selectTime;
          this.saveLoading = true;
          const params = this.planForm;
          params.stocktakingRecords = this.tempGoods;
          if (params.goodsRange == 3) {
            this.$delete(params, 'isAll');
            params.goodsCondition = this.goodsCondition;
          } else {
            params.isAll = (this.switchStatus === true || params.goodsRange == 1 ? 1 : 2);
            this.$delete(params, 'goodsCondition');
          }
          this.$delete(params, 'goodsRange');
          inventory.addStocktakingPlan(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('保存成功');
              this.handleToStocktakingPlan();
            } else {
              this.$Message.error(res.data.error);
            }
            this.saveLoading = false;
          }).catch((err) => {
            this.saveLoading = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写!');
        }
      });
    },
    nameExistValidator(rule, value, callback) {
      this.$store.commit('setDisableLoading', true);
      inventory.isStocktakingPlanNameExist({ name: value }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data) {
            callback(new Error('盘点名称已存在'));
          } else {
            callback();
          }
        } else {
          this.$Message.error(res.data.error);
          callback();
        }
      }).catch((err) => {
        utils.handleError(err);
        callback();
      });
    },
    // 确认重置
    confirmReset() {
      this.$refs.planForm.resetFields();
      this.indeterminate = false;
      this.checkAll = false;
      this.resetConfirmVisiable = false;
    },
    handleReset() {
      this.resetConfirmVisiable = true;
    },
    handleToStocktakingPlan() {
      this.$router.push({
        name: 'stocktakingPlan',
      });
    },
    handlePage(page) {
      this.page = page;
      this.getInventoryData();
    },
    handlePageSize(size) {
      this.size = size;
      this.page = 1;
      this.getInventoryData();
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.planForm.warehouseIds = this.allWarehouseIds;
        this.planForm.isAllWarehouse = this.checkAll === true ? 1 : 2;
      } else {
        this.planForm.warehouseIds = [];
      }
      this.handleSearch();
    },
    checkAllGroupChange(data) {
      this.tempGoods = [];
      if (data.length === this.warehouseList.length) { // warehouseList所有的仓库
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
      this.planForm.isAllWarehouse = this.checkAll === true ? 1 : 2;
      this.handleSearch();
    },
    handleTempSelect(selection, row) {
      if (!this.selectedTempGoodsIds.includes(row.id)) {
        this.tempGoods.push(row.id);
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoods.forEach((item, index) => {
        if (item === row.id) {
          this.tempGoods.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(item.id)) {
          this.tempGoods.push(item.id);
        }
      });
    },
    handleSelectAllCancel() {
      this.tempGoods = [];
    },
    getStoreList() {
      const params = {
        isGet: false
      }
      inventory.getOperatorLists(params).then(res => {
        if (res.data.status === 200) {
          if (res.data.data.length) {
            this.operatorList = res.data.data;
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    getOperatorRuleData() {
      inventory.getOperatorRules().then(res => {
        if (res.data.status === 200) {
          this.checkList = res.data.data.type || [];
          this.checkPatterns = res.data.data.pattern || [];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    operatorTypeSelect(value) {
      if (value == 2) { // 总部周盘
        this.planForm.goodsRange = 3;
      } else {
        this.planForm.goodsRange = 1;
      }
    },
    // 获取抽盘规则
    getDate() {
      const params = {
        id: 4, // 固定id
      };
      tools.getRuleDetail(params).then((res) => {
        if (res.data.status === 200) {
          const {
            goodsCondition,
            ruleName,
            goodsConditionDesc,
          } = res.data.data;
          this.ruleName = ruleName;
          this.goodsConditionDesc = goodsConditionDesc;
          this.goodsCondition = goodsCondition;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getWarehouseList();
    this.getInventoryData();
    this.getStoreList();
    this.getOperatorRuleData();
    this.getDate();
  },
};
</script>
<style lang="less" scoped>
  .pages{
    margin-top: 16px;
    text-align: right
  }
  .split-line {
    padding-bottom:6px;
    margin-bottom:6px;
    border-bottom: 1px solid #e9e9e9;
  }
  .leftMargin {
    left: 10px !important;
    margin-left: -80px !important;
  }
</style>
